import baseRoute from '../baseRoute';

export default `${baseRoute}/previousFieldReportTypes` as const;
